import type { SlideChapterDefinition } from '@/components/SlideWizard'
import Slide1Title from './slides/Slide1Title'
import Slide2Bridge from './slides/Slide2Bridge'
import Slide3GoogleYou from './slides/Slide3GoogleYou'
import Slide4MasterKey from './slides/Slide4MasterKey'
import Slide5Sarah from './slides/Slide5Sarah'
import Slide6TimeToReact from './slides/Slide6TimeToReact'
import Slide7FollowBreadcrumbs from './slides/Slide7FollowBreadcrumbs'
// import Slide8DefenceCheck from './slides/Slide8DefenceCheck'
import Slide9Close from './slides/Slide9Close'

export const buildDefencesV2Chapter: SlideChapterDefinition = {
  id: 'build-defences-v2',
  title: 'Digital Self-Defense',
  description: '5 simple habits that protect your accounts, money and peace of mind.',
  estimatedMinutes: 6,
  slides: [
    { id: 'bdv2-title', component: Slide1Title, label: 'Introduction' },
    { id: 'bdv2-bridge', component: Slide2Bridge, label: 'Harder to find' },
    { id: 'bdv2-google-you', component: Slide3GoogleYou, label: 'Keep social media private' },
    { id: 'bdv2-master-key', component: Slide4MasterKey, label: 'The master key problem' },
    { id: 'bdv2-sarah', component: Slide5Sarah, label: "Sarah's story" },
    { id: 'bdv2-time-to-react', component: Slide6TimeToReact, label: 'How fast can your bank help?' },
    { id: 'bdv2-breadcrumbs', component: Slide7FollowBreadcrumbs, label: 'Open the official app' },
    // { id: 'bdv2-defence-check', component: Slide8DefenceCheck, label: 'Your defence check', requiresInteraction: true },
    { id: 'bdv2-close', component: Slide9Close, label: 'Chapter summary' },
  ],
}
